<template>
    <div>
        <folderPage type="flow"/>
    </div>
</template>

<script>
import folderPage from '@/modules/business/folders/views/list.vue'
export default {
  components: {
    folderPage
  }
}
</script>
